<template>
  <div class="addressPicker">
    <van-area title="选择地址" :area-list="regions" @cancel="handle_close" @confirm="handle_change"	 />
  </div>
</template>

<script>
import regions from "../../../utils/regions";
export default {
  data() {
    return {
      regions: regions,
    };
  },
  methods: {
    handle_close() {
      this.$emit("close");
    },

    handle_change(e) {
      this.$emit("change", {
        detail: e,
      });
    },
  },
};
</script>
<style>
@import "./addressPicker.less";
</style>
